import {useEffect, useState} from "react";


function useDictionaryFilter(dictionary, propertyName, filter) {

    const [filteredDictionary, setFilteredDictionary] = useState([]);

    useEffect(() => {
        if (dictionary && filter) {
            const f = filter.toLowerCase().replace(/\s+/g, "");
            // console.log("filter", f);
            setFilteredDictionary(dictionary.filter(m => {
                const prop = decodeURIComponent(m[propertyName].toLowerCase().replaceAll("%20", "").replace(/\s+/g, ""));
                // console.log("filter prop", prop, "search", f);
                return prop.includes(f);
            }));
        } else {
            setFilteredDictionary(dictionary)
        }
    }, [dictionary, filter, propertyName])

    return filteredDictionary;
}


export default useDictionaryFilter;
